function H4(props) {
  const { children } = props;
  return (
    <h3 className="text-sm font-semibold">{children}</h3>
  );
}

export default H4;
